import React from 'react'
import classes from './inputs.module.css'
import { useField } from 'formik'
export const LoginInput = ({
    value,
    onChange,
    className = '',
    label = false,
    ...props
}) => {
    return (
        <div>
            {label && <span className={classes.inputLabel}>{label}</span>}
            <input
                className={`${classes.loginInput} ${classes.input} ${className}`}
                value={value}
                onChange={onChange}
                {...props}
            />
        </div>
    )
}

//TODO Make border color variable
export const FormInput = ({
    value,
    onChange,
    className = '',
    label = false,
    ...props
}) => {
    return (
        <div>
            {label && <span className={classes.inputLabel}>{label}</span>}
            <input
                className={`${classes.formInput} ${classes.input} ${className}`}
                value={value}
                onChange={onChange}
                {...props}
            />
        </div>
    )
}

//TODO Make height variable
export const FormTextArea = ({
    value,
    onChange,
    className = '',
    label = false,
    ...props
}) => {
    return (
        <div>
            {label && <span className={classes.inputLabel}>{label}</span>}
            <textarea
                className={`${classes.formTextArea} ${classes.input} ${className}`}
                value={value}
                onChange={onChange}
                {...props}
            />
        </div>
    )
}

export const ValidatedLoginInput = ({
    name,
    className = '',
    label = false,
    ...props
}) => {
    const [field, meta] = useField(name)

    return (
        <div>
            {label && <span className={classes.inputLabel}>{label}</span>}
            <input
                className={`${classes.loginInput} ${classes.input} ${className}`}
                {...props}
                {...field}
            />
            {meta.touched && meta.error && (
                <p className={classes.inputError}>{meta.error}</p>
            )}
        </div>
    )
}

export const ValidatedFormInput = ({
    name,
    className = '',
    label = false,
    ...props
}) => {
    const [field, meta] = useField(name)

    return (
        <div>
            {label && <span className={classes.inputLabel}>{label}</span>}
            <input
                className={`${classes.formInput} ${classes.input} ${className}`}
                {...props}
                {...field}
            />
            {meta.touched && meta.error && (
                <p className={classes.inputError}>{meta.error}</p>
            )}
        </div>
    )
}

export const ValidatedFormTextArea = ({
    name,
    className = '',
    label = false,
    ...props
}) => {
    const [field, meta] = useField(name)

    return (
        <div>
            {label && <span className={classes.inputLabel}>{label}</span>}
            <textarea
                className={`${classes.formTextArea} ${classes.input} ${className}`}
                {...props}
                {...field}
            />
            {meta.touched && meta.error && (
                <p className={classes.inputError}>{meta.error}</p>
            )}
        </div>
    )
}
